/*
 * @Description: 好借sdk通用
 * @Date: 2019-10-24 14:55:23
 * @LastEditTime: 2022-10-09 17:28:35
 */

// json类型的入参都是json字符串类型
const UA = navigator.userAgent;
const IOS = 'ios';
const ANDROID = 'android';
const os = /Android/i.test(UA) ? ANDROID : IOS;
const WIN = window;
const WINDOW_EVENT_PREFIX = 'window.XJJSBridge.eventMap.';
const versionInfo = UA.match(/JRHaoJie (\d+\.\d+\.\d+)/) || [];
const version = versionInfo[1] || '0.0.0';

function getCookie(name: string): string | null {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (!arr) {
        return null;
    } else {
        return arr[2];
    }
}

function compareVersion(higher: any, lower: any, isReal?: boolean): number {
    // 保持和58app操作一致
    // 新版本需要真实比较时，isReal传递true，默认不比较
    if (isReal) {
        const _higher = String(higher);
        const _lower = String(lower);
        if (_higher === _lower) {
            return 0;
        }
        const lVerson = _higher.split('.');
        const rVersion = _lower.split('.');
        const length = lVerson.length < rVersion.length ? lVerson.length : rVersion.length;
        // 使用最小的length循环，若都相等则比较长度
        for (let i = 0; i < length; i++) {
            if (lVerson[i] !== rVersion[i]) {
                return Number(lVerson[i]) - Number(rVersion[i]);
            }
        }
        return lVerson.length - rVersion.length;
    }
    return 1;
}

type nativeMethodParamsType = {
    method: string;
    isHold: boolean;
    argsTransfer?: (x: any, y?: (x: any) => void) => void;
    hasCallBack: boolean;
};

interface ImsgObj {
    methodName?: any;
    selector?: any;
    [propName: string]: any;
}

let XJJSBridge = {
    uid: 0,

    eventMap: {
        // 事件队列
    },

    actionsMap: {
        get_app_device_info: { name: 'getAppDeviceInfo', hasCallBack: false }, // 版本信息
        get_app_user_info: {
            name: 'getUserInfo',
            hasCallBack: false,
            argsTransfer: (data: any, callback: (x: any) => void) => {
                const _data = data && typeof data === 'string' ? JSON.parse(data) : data;
                callback(_data || {});
            },
        }, // sdk 获取手机号 ，身份证信息
        get_user_info: { name: 'getAppDeviceInfo', hasCallBack: false }, // 版本信息，58app中没有get_app_device_info，可使用get_user_info替代
        get_position: {
            name: 'getAppLocationInfo',
            hasCallBack: false,
            argsTransfer: (data: any, callback: (x: any) => void) => {
                const _data = data && typeof data === 'string' ? JSON.parse(data) : data;
                callback({ lon: _data.longitude || '', lat: _data.latitude || '', source: null });
            },
        }, // 获取经纬度信息
        get_app_version: { name: 'getAppVersion', hasCallBack: false }, // 版本信息
        upload_img: {
            name: 'uploadLocalImage',
            hasCallBack: true,
            argsTransfer: (data: any, callback: (x: any) => void) => {
                callback(
                    JSON.stringify({
                        cover: data && data[0],
                        urls: data || [],
                        state: data && data[0] ? '0' : '1',
                    }),
                );
            },
        }, // 上传图片
        pagetrans: { name: 'createNewWebView', hasCallBack: false }, // 打开页面
        close_webview: { name: 'closeNowWebview', hasCallBack: false }, // 关闭页面
        upload_local_image: { name: 'uploadLocalImage', hasCallBack: true },
        set_title: { name: 'setWebViewTitle', hasCallBack: false }, // 设置title
        login_mobile_dynamic: {
            name: 'openNativeLoginView',
            hasCallBack: compareVersion(version, '2.2.0', true) >= 0,
        }, // 手机验证码登录 2.2.0版本app增加callBack函数的处理
        bind_account: { name: 'needSuppleyPhoneNumber', hasCallBack: false }, // 绑定手机号
        listen_goback: { name: 'webViewWillGoBack', hasCallBack: true }, // 返回
        need_refresh: { name: 'needNativeHeadRefresh', hasCallBack: false }, // 设置是否可以下拉刷新（默认刷新），
        open_auth_sdk: { name: 'startFaceAuthenticateFlow', hasCallBack: true }, // 人脸认证
        jr_face_verify: { name: 'startSuppliersFaceAuthenticate', hasCallBack: true }, // 新版本人脸认证
        open_id_card_sdk: { name: 'showFillPersonInfomationPage', hasCallBack: true }, // 增验身份证信息
        is_login: { name: 'checkUserLogin', hasCallBack: false }, // 检查用户是否已登陆
        open_ocr_sdk: { name: 'startOcrAuthenticate', hasCallBack: true }, // 调用OCR照片识别检测
        device_event: { name: 'registerNativeBack', hasCallBack: true }, // 注册回退监听事件
        goback: { name: 'goBackNative', hasCallBack: false }, // 回退
        logout_to_home: { name: 'logoutToHome', hasCallBack: false }, // 退出登录并跳转到首页 好借单设备登录要用
        open_app: { name: 'open_app', hasCallBack: false },//打开浏览器
        extend_btn: { name: 'extend_right_btn', hasCallBack: true },//扩展native导航栏右侧按钮
        set_status_bar: { name: 'setStatusBar', hasCallBack: false },   // 设置好借状态栏字体颜色
        toggle_bounces: { name: 'toggleBounces', hasCallBack: false },  // 控制好借app-iOS端的回弹效果，默认关闭，参数bounces:1|0
        toggle_title_panel: { name: 'setTitleBar', hasCallBack: false }, // 好借app隐藏显示导航栏和状态栏
    },

    // 注册native调用js的事件队列
    addEventLoop(
        uidMethod: string,
        nativeMethodParams: nativeMethodParamsType,
        callback?: (x: any) => void,
    ) {
        if ((callback && nativeMethodParams.hasCallBack) || os === IOS) {
            this.eventMap[uidMethod] = (data: any) => {
                if (nativeMethodParams.argsTransfer) {
                    nativeMethodParams.argsTransfer(data, callback);
                } else if (callback) {
                    callback(data);
                }
                if (!nativeMethodParams.isHold) {
                    delete this.eventMap[uidMethod];
                }
            };
            this.uid = this.uid + 1;
        }
    },

    iosMethod(method: string, params?: any, callback?: (x: any) => void) {
        // ios通用方法
        const nativeMethodParams = this.getHaoJieMethodParams(method);
        const uidMethod = nativeMethodParams.method + this.uid;
        this.addEventLoop(uidMethod, nativeMethodParams, callback);
        try {
            const msgObj: ImsgObj = {};
            msgObj.selector = nativeMethodParams.method;
            if (callback) {
                if (!params) {
                    params = {};
                }
                params.methodName = WINDOW_EVENT_PREFIX + uidMethod;
            }
            if (params) {
                msgObj.params = params;
            }
            if (msgObj.params && Object.keys(msgObj.params).length) {
                msgObj.selector += ':';
            }

            window.webkit.messageHandlers.JSCallOC.postMessage(msgObj);
            // if (!nativeMethodParams.hasCallBack && data) {
            //     if (nativeMethodParams.argsTransfer) {
            //         nativeMethodParams.argsTransfer(data, callback);
            //     } else if (callback) {
            //         callback(data);
            //     }
            // }
        } catch (e) {
            console.error(JSON.stringify(e));
            console.error('需要在ios设备内使用WKWebView');
        }
    },

    androidMethod(method: string, params?: any, callback?: (x: any) => void) {
        // android通用方法
        const nativeMethodParams = this.getHaoJieMethodParams(method);
        const uidMethod = nativeMethodParams.method + this.uid;
        this.addEventLoop(uidMethod, nativeMethodParams, callback);
        try {
            const msgObj: ImsgObj = {};
            if (callback && nativeMethodParams.hasCallBack) {
                msgObj.methodName = WINDOW_EVENT_PREFIX + uidMethod;
            }
            if (params) {
                Object.assign(msgObj, params);
            }
            let data = null;
            if (Object.keys(msgObj).length === 0) {
                data = WIN.android[nativeMethodParams.method]();
            } else {
                data = WIN.android[nativeMethodParams.method](JSON.stringify(msgObj));
            }
            if (!nativeMethodParams.hasCallBack && data) {
                if (nativeMethodParams.argsTransfer) {
                    nativeMethodParams.argsTransfer(data, callback);
                } else if (callback) {
                    callback(data);
                }
            }
        } catch (e) {
            // alert('error:' + method);
            console.error(JSON.stringify(e));
            console.error('需要在android设备内使用JSBridge功能，无全局对象app');
        }
    },

    getHaoJieMethodParams(actionName: string): nativeMethodParamsType | Object {
        try {
            const step = this.actionsMap[actionName];
            return {
                method: step.name,
                isHold: step.isHold, // 注册事件 是否在调用完成之后销毁，默认销毁，默认值false
                argsTransfer: step.argsTransfer, // 转换回调的参数值
                hasCallBack: step.hasCallBack, // 是否有native调用js的回调函数
            };
        } catch (error) {
            console.error(`${actionName} 方法不存在`);
            return {}
        }
    },

    invoke(actionName: string, params: any, callback?: (x: any) => {}) {
        if (!this.actionsMap[actionName]) {
            console.error(`${actionName} 方法不存在`);
            return;
        }
        if (typeof params === 'function') {
            callback = params;
            params = {};
        }
        params = this.fixedWBAppActions(actionName, params);
        if (os === IOS) {
            this.iosMethod(actionName, params, callback);
        } else if (os === ANDROID) {
            this.androidMethod(actionName, params, callback);
        } else {
            console.error('请在native端使用此方法：' + actionName);
        }
    },

    fixedWBAppActions(actionName: string, params: any) {
        if (actionName === 'pagetrans') {
            return {
                url: params.content && params.content.url,
                title: params.content && params.content.title,
                navigationTitle: params.content && params.content.title,
                hide: (params.content && params.content.hide) || false,
                isHideNaviBar:(params.content && params.content.hide) || false,
            };
        }
        return params;
    },

    util: {
        compareVersion(higher: any, lower: any, isReal?: boolean): number {
            return compareVersion(higher, lower, isReal);
        },
    },

    headers: {
        isReady: true,
    },
};

if (UA.indexOf('JRXJSDK') !== -1 || UA.indexOf('JRHaoJie') !== -1) {
    // 定义空函数 ，防止报无用错误日志，业务暂时未用到，app那边无法处理
    window.webViewWillGoBack = () => { };
    window.webViewWillGoResume = () => { };
    window.webViewWillGoPause = () => { };
    // app请求用
    WIN.getPPU = (): string | null => {
        let ppu = getCookie('PPU');
        if (ppu) {
            ppu = ppu.split('"').join('');
        }
        return ppu;
    };
    Object.assign(WIN, { XJJSBridge });
} else if (/WUBA/i.test(UA) || /wbutown/i.test(UA)) {
    XJJSBridge = WIN.WBAPP;
    Object.assign(WIN, { XJJSBridge });
}

export default XJJSBridge;
